import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Trans } from "react-i18next";

interface ShineTitleProps {
  i18nKey: string;
  gradient?: string;
}

/*
 * Page title whose <shine> word carries a moving gradient.
 */
export const ShineTitle = ({ i18nKey, gradient }: ShineTitleProps) => {
  const theme = useTheme();
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const { dark, main, light } = theme.palette.primary;
  const background =
    gradient ??
    `linear-gradient(135deg, ${dark} 0%, ${main} 40%, ${light} 50%, ${main} 60%, ${light} 100%)`;

  return (
    <Typography
      component="h1"
      sx={{
        fontSize: "32px",
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: "center",
        margin: 0,
      }}
    >
      <Trans
        i18nKey={i18nKey}
        components={{
          shine: (
            <Box
              component="span"
              sx={{
                fontWeight: 800,
                letterSpacing: "1px",
                background,
                backgroundSize: "200% auto",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                display: "inline-block",
                verticalAlign: "baseline",
                animation: reducedMotion
                  ? "none"
                  : "titleShine 2.5s linear infinite",
                "@keyframes titleShine": {
                  to: { backgroundPosition: "-200% center" },
                },
              }}
            />
          ),
        }}
      />
    </Typography>
  );
};
